import { FaWhatsapp, FaInfoCircle, FaClock } from 'react-icons/fa';

const iconMap = {
  info: FaInfoCircle,
  clock: FaClock,
  default: FaInfoCircle,
};

const supportTitle = "Tehnical Support";
const supportPhone = "8801625192766";
const supportButtonText = "হোয়াটসঅ্যাপে যোগাযোগ করুন";

const supportDetails = [
    {
      icon: 'info',
      text: 'মেসেজ পাঠানোর সময়, আপনার নাম, পদবী এবং সমস্যার একটি স্ক্রিনশট বা বিস্তারিত বিবরণ দিন।'
    },
    {
      icon: 'clock',
      text: 'সাপোর্টের সময়: ( সকাল ১০টা - সন্ধ্যা ৬টা )'
    },
    {
      icon: 'clock',
      text: 'সাপোর্ট: ( শনি - বৃহস্পতিবার )'
    }
  ];

const mainMessage = (
  <p>
    যেকোনো প্রযুক্তিগত সহায়তার জন্য, অনুগ্রহ করে নিচের হোয়াটসঅ্যাপ নম্বরে যোগাযোগ করুন।
  </p>
);

const TechnicalSupportNotice = () => {
  return (
    <div className="bg-white shadow rounded-lg h-full flex flex-col">
      {/* Header */}
      <div className="p-4 border-b shrink-0">
        <h2 className="font-medium text-gray-800">{supportTitle}</h2>
      </div>
      
      {/* Content Area */}
      <div className="p-6 flex flex-col items-center flex-grow pt-8 pb-6">
        
        {/* Main WhatsApp Icon */}
        <div className="flex-shrink-0">
          <FaWhatsapp className="text-6xl text-green-500 mb-4" />
        </div>
        
        {/* Main Message  */}
        <div className="text-gray-700 text-base text-center px-4 mb-6">
          {mainMessage}
        </div>
        
        {/* --- Professional Details List  --- */}
        <div className="w-full max-w-xs p-4 bg-gray-100 rounded-lg text-left text-sm space-y-4 mb-6">
          {supportDetails.map((item, index) => {
            const IconComponent = iconMap[item.icon] || iconMap.default;
            return (
              <div key={index} className="flex items-start gap-3"> 
                <div className="flex-shrink-0 bg-blue-100 rounded-full p-2">
                  <IconComponent className="text-blue-600 h-4 w-4" /> 
                </div>
                <span className="text-gray-600 text-sm pt-[6px]">{item.text}</span>
              </div>
            );
          })}
        </div>
        {/* WhatsApp Button */}
        <a
          href={`https://wa.me/${supportPhone}`}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-auto inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-[#25D366] text-white rounded-md text-sm font-medium hover:bg-[#1DAE51] transition-all duration-300 shadow"
        >
          <FaWhatsapp className="text-xl" />
          {supportButtonText}
        </a>
      </div>
    </div>
  );
};

export default TechnicalSupportNotice;